import { ProjectInformation } from "../../project-plan/ProjectPlanPageState";

export type InputProjectInformationDialogState = {
  isShow: boolean;
  isCreate: boolean;
  saved: ProjectInformation;
  edited: ProjectInformation;
  codes: {
    trnsmsnType?: Option[];
    chnTypeGrpType?: Option[];
    usageType: Option[];
  };
  fieldPath: FieldPath;
  pjtId: string;
  updateDateTime: string;
  status: {
    ediUsage: string;
    invalidList: string[];
    isSaved: boolean;
  };
};

export type Option = {
  label: string;
  value: string;
};

export type FieldPath = {
  pjtName: string;
  pjtDesc: string;
  pjtStartPlnDate: string;
  pjtEndPlnDate: string;
  trnsMsnTypeCd: string;
  ediUsage: string;
  chnTypeGrpTypeCdList: string;
  reqEstmtAnsDueDate: string;
};

export type PageNewState =
  | InputProjectInformationDialogState
  | ((
      prevState: InputProjectInformationDialogState,
    ) => InputProjectInformationDialogState);
